import { RoomlayoutServiceRow } from "../Domain/Types/FacilityService-Roomlayout-row.types";

export const generateNewRoomlayoutId = (data: RoomlayoutServiceRow[] | undefined) => {
  if (!data?.length) return 1;
  return Math.max(...data.map(item => item.id ?? 0)) + 1;
};
